<px-o100-contact-footer
    [teaserHeadline]="_contactFooter.teaserHeadline"
    [teaserDescription]="_contactFooter.teaserDescription"
    [teaserLink]="_contactFooter.teaserLink"
    [teaserLinkName]="_contactFooter.teaserLinkName"
    [employees]="_contactFooter.employees"
></px-o100-contact-footer>
